var exports = {
  "UX": "PlutoniumUpsell.module__upsell___NlpBU3",
  "Kk": "PlutoniumUpsell.module__icon___NlpBU3",
  "Qs": "PlutoniumUpsell.module__content___NlpBU3",
  "Qq": "PlutoniumUpsell.module__text___NlpBU3",
  "o1": "PlutoniumUpsell.module__actions___NlpBU3",
  "R3": "PlutoniumUpsell.module__dismissLink___NlpBU3",
};

module.exports = exports;
